import { Node } from '@tiptap/core'

export interface IframeOptions {
  allowFullscreen: boolean
  HTMLAttributes: {
    [key: string]: any
  }
}

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    iframe: {
      /**
       * Add an iframe
       */
      setIframe: (options?: { src: string }) => ReturnType
      insertIframe: (src?: string, className?: string) => ReturnType
      setHtml: (value: string) => ReturnType
    }
  }
}

export const IFrameServerside = Node.create<IframeOptions>({
  name: 'iframe',

  group: 'block',
  content: 'inline*',
  draggable: true,

  atom: true,

  addOptions() {
    return {
      allowFullscreen: true,
      HTMLAttributes: {
        class: 'iframe-wrapper',
      },
    }
  },

  addAttributes() {
    return {
      src: {
        default: null,
      },
      frameborder: {
        default: 0,
      },
      allowfullscreen: {
        default: this.options.allowFullscreen,
        parseHTML: () => this.options.allowFullscreen,
      },
      sandbox: {
        default: 'allow-scripts allow-same-origin allow-forms allow-popups allow-presentation',
      },
      referrerpolicy: {
        default: 'no-referrer-when-downgrade',
      },
      width: {
        default: '100%',
      },
      height: {
        default: 'auto',
      },
      title: {
        default: null,
      },
      loading: {
        default: 'lazy',
      },
    }
  },

  parseHTML() {
    return [
      {
        tag: 'iframe',
      },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', this.options.HTMLAttributes, ['iframe', HTMLAttributes]]
  },
})
